import { WaIcon } from "./icons";
import { WHATSAPP_URL } from "@/lib/constants";

export const WaButton = ({ label = "Solicitar atendimento pelo WhatsApp", testId, className = "", big = false }) => {
  const track = () => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "whatsapp_click", location: testId || "wa-button" });
    } catch (e) {}
  };
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onClick={track}
    className={`group inline-flex items-center justify-center gap-3 rounded-full bg-wa font-semibold text-white shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-all duration-300 hover:bg-wa-hover hover:shadow-[0_14px_38px_rgba(37,211,102,0.5)] active:scale-[0.98] ${
      big ? "h-14 px-8 text-base sm:text-lg" : "h-12 px-6 text-sm sm:text-base"
    } ${className}`}
  >
    <WaIcon className={big ? "h-6 w-6" : "h-5 w-5"} />
    {label}
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`${big ? "h-5 w-5" : "h-4 w-4"} transition-transform duration-300 group-hover:translate-x-1`}
      aria-hidden="true"
    >
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </svg>
    </a>
  );
};
